import { ReactElement, ReactNode, useContext } from 'react';
import { useDispatch } from 'react-redux';
import { Accordion, AccordionContext, useAccordionButton } from 'react-bootstrap5';
import { hooks as commonHooks } from '@sitebuilder/common';
import { chevronRightBlack, expandIcon } from '../../assets/images';
import { actionCreators } from '../../reducers/templateEditor';

interface SideBarAccordionProps {
    children: ((ReactElement<any, any> & ReactNode) & ReactNode & JSX.Element) | JSX.Element[];
    toggleTitle?: string;
    eventKey: string;
    defaultActiveKey?: string;
    className?: string;
    toggelClassName?: string;
    accordionActiveKey?: string | string[];
    onClickAccordion?: (e: any) => any;
    itemInfo?: any;
    isExpandable?: boolean;
}

interface CustomToggleProps {
    title?: string;
    eventKey: string;
    callback?: (e: any) => any;
    className?: string;
    onClickAccordion?: (e: any) => any;
    itemInfo?: any;
    isExpandable?: boolean;
}

const CustomToggle = ({
    title,
    eventKey,
    callback,
    className,
    onClickAccordion,
    itemInfo,
    isExpandable,
}: CustomToggleProps) => {
    const accordionContext = useContext(AccordionContext);
    const i18n = commonHooks.useLocalization();
    const dispatch = useDispatch();
    const onClickToggle = useAccordionButton(eventKey, () => {
        callback && callback(eventKey);
        onClickAccordion && onClickAccordion(eventKey);
    });

    const isOpen = Array.isArray(accordionContext.activeEventKey)
        ? accordionContext.activeEventKey.includes(eventKey)
        : accordionContext.activeEventKey === eventKey;

    return (
        <div className={`collapsed accordion-toggle ${className || ''}`} onClick={onClickToggle}>
            <span data-testid="title-accordion">
                {itemInfo && itemInfo.headers['ldr-type'] ? i18n.t('folder_information') : title}
            </span>

            <div>
                {isExpandable && isOpen && (
                    <img
                        className="expand-icon"
                        src={expandIcon}
                        alt="expand-icon"
                        onClick={(e: React.MouseEvent<HTMLElement>) => {
                            e.preventDefault();
                            e.stopPropagation();
                            title && dispatch(actionCreators.addBottomBarTab(title));
                        }}
                    />
                )}

                <img
                    className={`toggle-icon ${isOpen ? 'close-toggle-icon' : ''}`}
                    src={chevronRightBlack}
                    alt="toggle-icon"
                />
            </div>
        </div>
    );
};

const SideBarAccordion = (props: SideBarAccordionProps) => {
    const { toggleTitle, eventKey, defaultActiveKey, itemInfo, ...rest } = props;

    return (
        <div className={`accordion-group ${rest.className || ''}`}>
            <Accordion
                className="side-bar-accordion"
                defaultActiveKey={defaultActiveKey}
                activeKey={rest.accordionActiveKey || defaultActiveKey}
            >
                <CustomToggle
                    title={toggleTitle}
                    eventKey={eventKey}
                    className={rest.toggelClassName}
                    onClickAccordion={rest.onClickAccordion}
                    itemInfo={itemInfo}
                    isExpandable={rest.isExpandable}
                />
                <Accordion.Collapse eventKey={eventKey}>
                    <div className="accordion-content">{props.children}</div>
                </Accordion.Collapse>
            </Accordion>
            <hr className="divider" />
        </div>
    );
};

export default SideBarAccordion;
